import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const carousel = document.querySelector('.propertyGallery');
  const carousel2 = document.querySelector('.propertyGallery2');

  if (carousel && carousel2) {
    const swiper = new Swiper(carousel, {
      spaceBetween: 16,
      slidesPerView: 4.33,
      freeMode: true,
      watchSlidesProgress: true,
    });
    new Swiper(carousel2, {
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper,
      },
    });
  }
});
